export default __webpack_public_path__ + "static/media/background.6f1e8366.png";